var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedFolderPrivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71429 4.02884V3.67188C7.71429 1.71197 6.12839 0.107874 4.19673 0.00521912C4.23482 0.00176518 4.27344 0 4.31251 0H8.68751L10.4375 1.83333H15.6875C16.3984 1.83333 17 2.46354 17 3.20833V9.625C17 10.3984 16.3984 11 15.6875 11H7.14287C8.13081 11 9.00001 10.2113 9.00001 9.15625V5.78125C9.00001 4.9596 8.44933 4.26956 7.71429 4.02884ZM3.71429 3.9375V3.67188C3.71429 3.54443 3.83217 3.40625 4.00001 3.40625C4.06721 3.40625 4.14157 3.43465 4.20251 3.49463C4.26343 3.5546 4.28572 3.62064 4.28572 3.67188V3.9375H3.71429Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14286 4.9375H6.71429V3.67188C6.71429 2.21289 5.48214 1 4 1C2.5 1 1.28571 2.21289 1.28571 3.67188V4.9375H0.857143C0.375 4.9375 0 5.32422 0 5.78125V9.15625C0 9.63086 0.375 10 0.857143 10H7.14286C7.60714 10 8 9.63086 8 9.15625V5.78125C8 5.32422 7.60714 4.9375 7.14286 4.9375ZM5.28571 4.9375H2.71429V3.67188C2.71429 2.98633 3.28571 2.40625 4 2.40625C4.69643 2.40625 5.28571 2.98633 5.28571 3.67188V4.9375Z",
    fill: "#009A49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedFolderPrivate);
export default __webpack_public_path__ + "static/media/closedFolderPrivate.a0267d2f.svg";
export { ForwardRef as ReactComponent };